<template>
  <div
    class="discipline-amount-cell"
    :class="{
      'discipline-amount-cell-red': record.is.value === 'Штраф',
      'discipline-amount-cell-green': record.is.value === 'Премия',
    }"
  >
    <c-button
      v-if="record.isFined == 1"
      v-b-popover.html="{ container: '#app', trigger: 'hover blur', content: 'Штраф увеличен', placement: 'top' }"
      class="discipline-amount-cell-up"
      icon="up"
      size="iconic"
    />
    <div v-else></div>
    <span>{{ formatAmount(record.summ.value) || 0 }}</span>
  </div>
</template>

<script>
import Button from "@/components/controls2/Button";

export default {
  name: "discipline-amount-cell",
  components: {
    "c-button": Button,
  },
  props: ["record"],
  methods: {
    numberWithSpaces(x) {
      if (x > 0) {
        return `+ ${x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      if (x < 0) {
        return `- ${(-1 * x).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}`;
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
    formatAmount(x) {
      if (!x) {
        return "";
      }

      if (!Number.isInteger(x)) {
        return x
          .toFixed(2)
          .toString()
          .replace(/\B(?=(\d{3})+(?!\d))/g, " ");
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.discipline-amount-cell {
  line-height: 13px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 13px;
  text-align: right;
  padding: 10px !important;
  -webkit-transition: font 0.3s ease;
  transition: font 0.3s ease;

  @media screen and (max-width: 700px) {
    justify-content: flex-start;
  }

  &-up {
    display: inline-block;
    margin-left: -5px;
  }

  & span {
    margin-left: 20px;

    @media screen and (max-width: 700px) {
      margin-left: 0;
    }
  }

  &-green {
    color: #12c971;
  }

  &-red {
    color: #ff238d;
  }
}
</style>
